import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import logo from "../../SBA-Logo.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context";
import "./sidebar.css";

/**
 * @typedef {
 *   | "home"
 *   | "overview"
 *   | "membership-types"
 *   | "demographics"
 *   | "subscriptions"
 *   | "revenue"
 *   | "retention"
 *   | "members"
 *   | "sales-overview"
 *   | "sales-by-store"
 *   | "sales-by-category"
 *   | "sales-by-agent"
 *   | "sales-top-products"
 *   | "sales-hourly"
 *   | "sales-payments"
 *   | "stocks-overview"
 *   | "stocks-balance"
 *   | "stocks-movement"
 *   | "stocks-adjustment"
 *   | "stocks-consumption"
 *   | "stocks-reorder"
 *   | "stocks-valuation"
 * } ReportKey
 */

/**
 * @typedef {Object} LeafItem
 * @property {ReportKey} key
 * @property {string} label
 * @property {string} icon
 */

/**
 * @typedef {
 *   | { kind: "leaf", key: ReportKey, label: string, icon: string }
 *   | { kind: "group", id: string, label: string, icon: string, children: LeafItem[] }
 * } MenuItem
 */

// interface SidebarItem {
//   key: ReportKey;
//   label: string;
//   icon: string;
//   group: string;
// }

// const ITEMS: SidebarItem[] = [
//   { key: "overview", label: "Overview", icon: "bi-speedometer2", group: "Summary" },
//   { key: "membership-types", label: "Membership Types", icon: "bi-collection", group: "Summary" },
//   { key: "demographics", label: "Demographics", icon: "bi-people", group: "Members" },
//   { key: "retention", label: "Active vs Inactive", icon: "bi-person-check", group: "Members" },
//   { key: "subscriptions", label: "Subscriptions", icon: "bi-credit-card-2-front", group: "Finance" },
//   { key: "revenue", label: "Revenue & Spend", icon: "bi-cash-stack", group: "Finance" },
//   { key: "members", label: "Members Directory", icon: "bi-table", group: "Data" },
// ];

// const ITEMS: MenuItem[]

/** @type {MenuItem[]} */
const MENU = [
  // { kind: "leaf", key: "home", label: "Home", icon: "bi-house-door-fill" },
  {
    kind: "group",
    id: "membership",
    label: "Membership",
    icon: "bi-people-fill",
    children: [
      { key: "overview", label: "Overview", icon: "bi-speedometer2" },
      {
        key: "membership-types",
        label: "Membership Types",
        icon: "bi-collection",
      },
      { key: "demographics", label: "Demographics", icon: "bi-people" },
      {
        key: "retention",
        label: "Active vs Inactive",
        icon: "bi-person-check",
      },
      {
        key: "subscriptions",
        label: "Subscriptions",
        icon: "bi-credit-card-2-front",
      },
      { key: "revenue", label: "Revenue & Spend", icon: "bi-cash-stack" },
      { key: "members", label: "Members Directory", icon: "bi-table" },
    ],
  },
  {
    kind: "group",
    id: "sales",
    label: "Sales",
    icon: "bi-bag-check-fill",
    children: [
      { key: "sales-overview", label: "Overview", icon: "bi-speedometer2" },
      { key: "sales-record", label: "Sales Record", icon: "bi-receipt" },
      { key: "sales-by-store", label: "Sales by Store", icon: "bi-shop" },
      {
        key: "sales-by-category",
        label: "Sales by Category",
        icon: "bi-tags-fill",
      },
      {
        key: "sales-by-agent",
        label: "Sales Agent's Report",
        icon: "bi-person-badge-fill",
      },
      {
        key: "sales-top-products",
        label: "Top Products",
        icon: "bi-trophy-fill",
      },
      {
        key: "sales-hourly",
        label: "Hourly / Daily Trend",
        icon: "bi-clock-history",
      },
      {
        key: "sales-payments",
        label: "Payment Methods",
        icon: "bi-credit-card-fill",
      },
    ],
  },
  {
    kind: "group",
    id: "stocks",
    label: "Stocks",
    icon: "bi-box-seam-fill",
    children: [
      // { key: "stocks-overview", label: "Overview", icon: "bi-speedometer2" },
      { key: "stocks-balance", label: "Item Balance Report", icon: "bi-boxes" },
      // {
      //   key: "stocks-movement",
      //   label: "Stock Movement",
      //   icon: "bi-arrow-left-right",
      // },
      // {
      //   key: "stocks-adjustment",
      //   label: "Stock Adjustment",
      //   icon: "bi-sliders",
      // },
      // {
      //   key: "stocks-consumption",
      //   label: "Stock Consumption",
      //   icon: "bi-basket-fill",
      // },
      { key: "stocks-reorder", label: "Reorder Alerts", icon: "bi-bell-fill" },
      // {
      //   key: "stocks-valuation",
      //   label: "Stock Valuation",
      //   icon: "bi-cash-stack",
      // },
      {
        key: "stocks-closing",
        label: "Stock Closing Entries",
        icon: "bi-basket-fill",
      },
    ],
  },
  {
    kind: "group",
    id: "financial",
    label: "Financial Position",
    icon: "bi-bank",
    children: [
      {
        key: "income-statement",
        label: "Income Statement",
        icon: "bi-file-earmark-spreadsheet",
      },
    ],
  },
];

// ✅ Route mapping
const routeMap = {
  // membership
  overview: "/retailone-dashboard",
  "membership-types": "/retailone-dashboard/membership-types",
  demographics: "/retailone-dashboard/demographics",
  retention: "/retailone-dashboard/retention",
  subscriptions: "/retailone-dashboard/subscriptions",
  revenue: "/retailone-dashboard/revenue",
  members: "/retailone-dashboard/members",
  // sales
  "sales-overview": "/retailone-dashboard/sales-overview",
  "sales-record": "/retailone-dashboard/sales-record",
  "sales-by-store": "/retailone-dashboard/sales-by-store",
  "sales-by-category": "/retailone-dashboard/sales-by-category",
  "sales-by-agent": "/retailone-dashboard/sales-by-agent",
  "sales-top-products": "/retailone-dashboard/top-products",
  "sales-hourly": "/retailone-dashboard/sales-hourly",
  "sales-payments": "/retailone-dashboard/payment-methods",
  // stocks
  "stocks-balance": "/retailone-dashboard/item-balance-report",
  "stocks-reorder": "/retailone-dashboard/reorder-status",
  "stocks-closing": "/retailone-dashboard/stock-closing-entries",
  // financial
  "income-statement": "/retailone-dashboard/income-statement",
  // other
  roles: "/retailone-dashboard/roles",
  permissions: "/retailone-dashboard/permissions",
  users: "/retailone-dashboard/users",
  invite: "/retailone-dashboard/invite",
};

/**
 * @param {Object} props
 * @param {ReportKey} props.active
 * @param {(k: ReportKey) => void} props.onSelect
 * @param {boolean} props.collapsed
 * @param {(id: string) => void} props.onSelectModule
 */
export function Sidebar({ active, onSelect, collapsed, onSelectModule }) {
  const navigate = useNavigate();
  // ✅ Get permission helpers from auth
  const { canAccess } = useAuth();

  // ✅ Access Control: company has role_management AND user has roles.view
  const showAccessControl = canAccess("role_management", "roles.view");
  // ✅ Setup: company has user_management AND user has users.view
  const showSetup = canAccess("user_management", "users.view");

  /** @type {Record<string, boolean>} */
  const initialOpen = {};
  MENU.forEach((m) => {
    if (m.kind === "group") {
      initialOpen[m.id] = m.children.some((c) => c.key === active);
    }
  });
  const [open, setOpen] = useState(initialOpen);
  const [showAccessControlDropdown, setShowAccessControlDropdown] =
    useState(false);
  const [showSetupDropdown, setShowSetupDropdown] = useState(false);
  const accessControlTimeoutRef = React.useRef(null);
  const setupTimeoutRef = React.useRef(null);

  /** @param {string} id */
  const toggle = (id) => {
    Object.keys(open).forEach((key) => {
      open[key] = false;
    });
    setOpen((o) => ({ ...o, [id]: !o[id] }));
  };

  // Access Control hover handlers
  const handleAccessControlMouseEnter = () => {
    if (accessControlTimeoutRef.current) {
      clearTimeout(accessControlTimeoutRef.current);
      accessControlTimeoutRef.current = null;
    }
    setShowAccessControlDropdown(true);
  };

  const handleAccessControlMouseLeave = () => {
    accessControlTimeoutRef.current = setTimeout(() => {
      setShowAccessControlDropdown(false);
    }, 300);
  };

  const handleAccessControlDropdownMouseEnter = () => {
    if (accessControlTimeoutRef.current) {
      clearTimeout(accessControlTimeoutRef.current);
      accessControlTimeoutRef.current = null;
    }
    setShowAccessControlDropdown(true);
  };

  const handleAccessControlDropdownMouseLeave = () => {
    accessControlTimeoutRef.current = setTimeout(() => {
      setShowAccessControlDropdown(false);
    }, 300);
  };

  // Setup hover handlers
  const handleSetupMouseEnter = () => {
    if (setupTimeoutRef.current) {
      clearTimeout(setupTimeoutRef.current);
      setupTimeoutRef.current = null;
    }
    setShowSetupDropdown(true);
  };

  const handleSetupMouseLeave = () => {
    setupTimeoutRef.current = setTimeout(() => {
      setShowSetupDropdown(false);
    }, 300);
  };

  const handleSetupDropdownMouseEnter = () => {
    if (setupTimeoutRef.current) {
      clearTimeout(setupTimeoutRef.current);
      setupTimeoutRef.current = null;
    }
    setShowSetupDropdown(true);
  };

  const handleSetupDropdownMouseLeave = () => {
    setupTimeoutRef.current = setTimeout(() => {
      setShowSetupDropdown(false);
    }, 300);
  };

  return (
    <aside className={`pbi-sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="pbi-sidebar-header">
        <div className="pbi-logo">
          <img src={logo} alt="Logo" className="App-logo" />
        </div>
        {!collapsed && (
          <div>
            <div className="pbi-brand">SBA</div>
            <div className="pbi-brand-sub">Analytics</div>
          </div>
        )}
      </div>

      <Nav className="flex-column pbi-nav">
        {MENU.map((item) => {
          if (item.kind === "leaf") {
            return (
              <button
                key={item.key}
                className={`pbi-nav-item ${active === item.key ? "active" : ""}`}
                onClick={() => {
                  onSelect(item.key);
                  onSelectModule(item.key);
                }}
                title={item.label}
              >
                <i className={`bi ${item.icon}`} />
                {!collapsed && <span>{item.label}</span>}
              </button>
            );
          }
          const isOpen = collapsed ? true : !!open[item.id];
          const hasActiveChild = item.children.some((c) => c.key === active);
          return (
            <div key={item.id} className="pbi-nav-group">
              <button
                className={`pbi-nav-item pbi-nav-parent ${hasActiveChild ? "has-active" : ""}`}
                onClick={() => (collapsed ? undefined : toggle(item.id))}
                title={item.label}
              >
                <i className={`bi ${item.icon}`} />
                {!collapsed && (
                  <>
                    <span>{item.label} </span>
                    <i
                      className={`bi ${isOpen ? "bi-chevron-down" : "bi-chevron-right"} pbi-caret`}
                    />
                  </>
                )}
              </button>
              {isOpen && (
                <div className={`pbi-submenu ${collapsed ? "collapsed" : ""}`}>
                  {item.children.map((child) => {
                    const route = routeMap[child.key] || "/retailone-dashboard";
                    return (
                      <button
                        key={child.key}
                        className={`pbi-nav-item pbi-nav-child ${active === child.key ? "active" : ""}`}
                        onClick={() => {
                          onSelect(child.key);
                          onSelectModule(item.id);
                          // navigate(route);
                        }}
                        title={child.label}
                      >
                        <i className={`bi ${child.icon}`} />
                        {!collapsed && <span>{child.label}</span>}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </Nav>

      {/* ============================================================
          ACCESS CONTROL - Just above Setup
          ✅ Only shows if company has role_management AND user has roles.view
          ============================================================ */}
      {showAccessControl && (
        <div
          className="pbi-nav-group"
          style={{ position: "relative" }}
          onMouseEnter={handleAccessControlMouseEnter}
          onMouseLeave={handleAccessControlMouseLeave}
        >
          <button
            className="pbi-nav-item"
            title="Access Control"
            onClick={() =>
              setShowAccessControlDropdown(!showAccessControlDropdown)
            }
          >
            <i className="bi bi-shield-lock-fill"></i>
            {!collapsed && <span>Access Control</span>}
          </button>

          {showAccessControlDropdown && !collapsed && (
            <div
              className="setup-dropdown"
              onMouseEnter={handleAccessControlDropdownMouseEnter}
              onMouseLeave={handleAccessControlDropdownMouseLeave}
            >
              <button
                className="setup-dropdown-item"
                onClick={() => {
                  navigate("/retailone-dashboard/roles");
                  setShowAccessControlDropdown(false);
                }}
              >
                <i className="bi bi-shield"></i>
                Roles
              </button>
              <button
                className="setup-dropdown-item"
                onClick={() => {
                  navigate("/retailone-dashboard/permissions");
                  setShowAccessControlDropdown(false);
                }}
              >
                <i className="bi bi-lock"></i>
                Permissions
              </button>
            </div>
          )}
        </div>
      )}

      {/* ============================================================
          SETUP - At the very bottom
          ✅ Only shows if company has user_management AND user has users.view
          ============================================================ */}
      {showSetup && (
        <div
          className="pbi-nav-group"
          style={{ marginTop: "auto", position: "relative" }}
          onMouseEnter={handleSetupMouseEnter}
          onMouseLeave={handleSetupMouseLeave}
        >
          <button
            className="pbi-nav-item"
            title="Setup"
            onClick={() => setShowSetupDropdown(!showSetupDropdown)}
          >
            <i className="bi bi-gear-fill" />
            {!collapsed && <span>Setup</span>}
          </button>

          {showSetupDropdown && !collapsed && (
            <div
              className="setup-dropdown"
              onMouseEnter={handleSetupDropdownMouseEnter}
              onMouseLeave={handleSetupDropdownMouseLeave}
            >
              <button
                className="setup-dropdown-item"
                onClick={() => {
                  navigate("/retailone-dashboard/users");
                  setShowSetupDropdown(false);
                }}
              >
                <i className="bi bi-people"></i>
                Users
              </button>
              <button
                className="setup-dropdown-item"
                onClick={() => {
                  navigate("/retailone-dashboard/invite");
                  setShowSetupDropdown(false);
                }}
              >
                <i className="bi bi-envelope"></i>
                Invitations
              </button>
              <button
                className="setup-dropdown-item"
                onClick={() => {
                  navigate("/retailone-dashboard/roles");
                  setShowSetupDropdown(false);
                }}
              >
                <i className="bi bi-shield"></i>
                Roles
              </button>
            </div>
          )}
        </div>
      )}

      {!collapsed && (
        <div className="pbi-sidebar-footer">
          <div className="text-muted small">v1.0 · Live data</div>
        </div>
      )}
    </aside>
  );
}
